/**
 * @module types/settings/legendColors
 * @description 图例颜色映射（存储字段名 `legend_colors`）
 *
 * key：图例标识；value：rgba 字符串，如 `rgba(110, 119, 148, 1)`
 */

/** 图例 key → rgba */
export type TLegendColors = Record<string, string>;

/**
 * 空 legend_colors 的模块级默认引用
 *
 * 恢复默认时写入 `{}` 的 draft 副本（新对象），使展示回退调色板而非 base 历史色。
 *
 * @stable 未落库时 selector 返回本冻结空对象引用
 */
export const LEGEND_COLORS_DEFAULT: TLegendColors = Object.freeze(
  {},
) as TLegendColors;
